<div class="responsive-card">
  <div class="responsive-card-title" i18n>Affected Accounts</div>
  <div class="d-flex flex-column">
    <ng-container *ngFor="let account of accounts; let last = last">
      <app-affected-account [account]="account" [lastInList]="last" />
    </ng-container>
  </div>
</div>
